import styled from "styled-components";

export const FestivalEventITMWrapper = styled.div<{
  contentHeight?: number;
}>`
  background: #f0f0f0;
  border-bottom: 1px solid #d9d9d9;
  width: 100%;
  padding: 15px 16px 20px;
  height: ${(p) => (p.contentHeight ? `${p.contentHeight}px` : "56px")};
  transition: height 0.5s ease-in-out;
  overflow: hidden;
`;

export const FestivalEventITMHeader = styled.div<{ open: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 12px;

  > .title {
    font-weight: 700;
    font-size: 16px;
    color: var(--Black-400, #444444);
  }

  > img {
    width: 24px;
    height: 24px;
    rotate: ${(p) => (p.open ? "180deg" : "0")};
    transition: all 0.2s ease-in-out;
  }
`;

export const FestivalEventITMBack = styled.div<{ open: boolean }>`
  width: 100%;
  border-radius: 12px;
  padding: 20px 15px 30px;
  background: #fff;
  opacity: ${(p) => (p.open ? "1" : "0")};
  transition: opacity 0.4s ease-in-out;
`;

export const FestivalEventITMTable = styled.div<{ isHeight: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 4px;
  ${(p) => (p.isHeight ? "min-height: 346px;" : "")}
  margin-bottom: 22px;
`;

export const FestivalEventITMItem = styled.div`
  background: #f0f0f0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 12px;
  height: 46px;
  border-radius: 8px;

  > .user {
    display: flex;
    gap: 10px;
    align-items: center;

    > .rank {
      width: 35px;
      text-align: center;
      font-family: Pretendard;
      font-weight: 700;
      font-size: 14px;
      color: #121212;
    }

    > .nickname {
      color: #121212;
      font-weight: 700;
      font-size: 14px;
    }
  }

  > .point {
    color: #121212;
    font-weight: 700;
    font-size: 14px;
  }
`;
